import Badge from '@shared/components/Badge/Badge';

import useNotifications from './NotificationsProvider/useNotifications';

const UnreadNotificationsCountBadge = () => {
  const { notificationsState } = useNotifications();

  const unreadCount = notificationsState.filter((notification) => !notification.isRead).length;
  if (!unreadCount) return null;

  const formattedUnreadCount = unreadCount > 99 ? '99+' : unreadCount;

  return (
    <Badge size="md" className="absolute -top-1 -right-1">
      {formattedUnreadCount}
    </Badge>
  );
};

export default UnreadNotificationsCountBadge;
